const mimeType = {
    PDF : 'application/pdf',

    SWF : 'application/x-shockwave-flash'

};

angular.module('gw-um-j2js')
    .constant('mimeType', mimeType);